import { render } from "./Presentation.vue?vue&type=template&id=33336a91&scoped=true"
import script from "./Presentation.vue?vue&type=script&lang=js"
export * from "./Presentation.vue?vue&type=script&lang=js"

import "./Presentation.vue?vue&type=style&index=0&id=33336a91&scoped=true&lang=css"

import exportComponent from "/builds/tapetum1/tapetum-landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33336a91"]])

export default __exports__